import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";

import { EnrollmentManagerService } from "src/app/services/enrollment-manager.service";

@Component({
    selector: 'mwp-benefit-enrollment-wizard-control',
    templateUrl: './benefit-wizard-control.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BenefitWizardControlComponent implements OnInit {
    @Input() public isContinueDisabled: boolean;
    @Input() public isCheckout: boolean;
    @Output() public emitComplete: EventEmitter<any> = new EventEmitter();

    public displayBackButton: boolean;
    public displayCancelButton: boolean;

    constructor(
        private enrollmentManagerService: EnrollmentManagerService,
    ) {
    }

    ngOnInit() {
        this.displayCancelButton = this.isCheckout != true;
    }

    public complete(): void {
        this.emitComplete.emit();
    }

    public cancel(): void {
        this.enrollmentManagerService.$CancelBenefitWizard.next(true);
    }

    public back(): void {
        this.enrollmentManagerService.$BackPanelBenefitWizard.next(true);
    }
}
